
import { Component, Vue } from "vue-property-decorator";
@Component
export default class Logout extends Vue {
  public modalShow = false;
  public text = "";
  public show(text) {
    this.text = text;
    this.modalShow = true;
  }
}
